import React from 'react';
import Input from 'components/ui/Input';
import Select from 'components/ui/Select';
import Button from 'components/ui/Button';

const GuestDetailsForm = ({ formData, onUpdate, onNext, onBack }) => {
  const titleOptions = [
    { value: 'mr', label: 'Mr.' },
    { value: 'mrs', label: 'Mrs.' },
    { value: 'ms', label: 'Ms.' },
    { value: 'dr', label: 'Dr.' }
  ];

  const countryOptions = [
    { value: 'in', label: 'India' },
    { value: 'us', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'ca', label: 'Canada' },
    { value: 'au', label: 'Australia' }
  ];

  const dietaryOptions = [
    { value: 'none', label: 'No dietary restrictions' },
    { value: 'vegetarian', label: 'Vegetarian' },
    { value: 'vegan', label: 'Vegan' },
    { value: 'gluten-free', label: 'Gluten-free' },
    { value: 'other', label: 'Other (specify in special requests)' }
  ];

  const isFormValid = () => {
    return (formData?.title &&
    formData?.firstName &&
    formData?.lastName &&
    formData?.phone && formData?.country);
  };

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <h3 className="text-lg font-heading font-semibold text-card-foreground mb-4">
          Primary Guest Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <Select
            label="Title"
            placeholder="Select title"
            options={titleOptions}
            value={formData?.title}
            onChange={(value) => onUpdate({ title: value })}
            required
          />

          <Input
            label="First Name"
            type="text"
            placeholder="Enter first name"
            value={formData?.firstName}
            onChange={(e) => onUpdate({ firstName: e?.target?.value })}
            required
          />

          <Input
            label="Last Name"
            type="text"
            placeholder="Enter last name"
            value={formData?.lastName}
            onChange={(e) => onUpdate({ lastName: e?.target?.value })}
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <Input
            label="Email Address (optional)"
            type="email"
            placeholder="Enter email address"
            value={formData?.email}
            onChange={(e) => onUpdate({ email: e?.target?.value })}
            description="We'll send confirmation here if provided"
          />

          <Input
            label="Phone Number"
            type="tel"
            placeholder="Enter phone number"
            value={formData?.phone}
            onChange={(e) => onUpdate({ phone: e?.target?.value })}
            required
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <Select
            label="Country"
            placeholder="Select country"
            options={countryOptions}
            value={formData?.country}
            onChange={(value) => onUpdate({ country: value })}
            required
          />

          {/* Date of Birth field removed as per requirements */}
        </div>

        <Input
          label="From"
          type="text"
          placeholder="City / Place you are coming from"
          value={formData?.from}
          onChange={(e) => onUpdate({ from: e?.target?.value })}
        />
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="text-md font-heading font-semibold text-card-foreground mb-4">
          Preferences & Special Requests
        </h4>

        <div className="space-y-4">
          <Select
            label="Dietary Preferences"
            placeholder="Select dietary preference"
            options={dietaryOptions}
            value={formData?.dietary}
            onChange={(value) => onUpdate({ dietary: value })}
          />

          <div>
            <label className="block text-sm font-medium text-card-foreground mb-2">
              Special Requests
            </label>
            <textarea
              placeholder="Any special requests or requirements (e.g., early check-in, room preferences, celebration arrangements)"
              value={formData?.specialRequests}
              onChange={(e) => onUpdate({ specialRequests: e?.target?.value })}
              rows={4}
              className="w-full px-3 py-2 border border-border rounded-md text-card-foreground bg-input focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
            />
          </div>

          <div className="flex items-start space-x-3">
            <input
              type="checkbox"
              id="newsletter"
              checked={formData?.newsletter}
              onChange={(e) => onUpdate({ newsletter: e?.target?.checked })}
              className="w-4 h-4 text-primary mt-1"
            />
            <label htmlFor="newsletter" className="text-sm text-card-foreground">
              Subscribe to our newsletter for exclusive offers and updates about Dandeli Adventure Resorts
            </label>
          </div>

          <div className="flex items-start space-x-3">
            <input
              type="checkbox"
              id="terms"
              checked={formData?.agreeTerms}
              onChange={(e) => onUpdate({ agreeTerms: e?.target?.checked })}
              className="w-4 h-4 text-primary mt-1"
              required
            />
            <label htmlFor="terms" className="text-sm text-card-foreground">
              I agree to the{' '}
              <a href="#" className="text-primary hover:underline">
                Terms & Conditions
              </a>{' '}
              and{' '}
              <a href="#" className="text-primary hover:underline">
                Privacy Policy
              </a>
            </label>
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <Button
          variant="outline"
          onClick={onBack}
          iconName="ArrowLeft"
          iconPosition="left"
        >
          Back to Dates
        </Button>

        <Button
          variant="default"
          onClick={onNext}
          disabled={!isFormValid() || !formData?.agreeTerms}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Continue to Payment
        </Button>
      </div>
    </div>
  );
};

export default GuestDetailsForm;